import { DialogActions, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
// import { useState } from 'react';
import { parseErrorMessage } from '../../../../../../core/api/api.context';
import { FormControl } from '../../../../../../ui/components/pure/form-control/form-control.component';
import { TwoPaneModalContent } from '../../../../../../ui/components/pure/modal-content/two-pane-modal-content.component';
import { TextField } from '../../../../../../ui/components/pure/text-field/text-field.component';
import { useMobilePhoneFormatter } from '../../../../../../ui/formatters/mobile-phone.formatter';
import { mobilePhoneValidator } from '../../../../../../ui/util/mobile-phone.validator';
import { useBookOrderActionContext } from '../book-order-action.context';
import { AllStepsLeftSide } from '../shared-components/all-steps-left-side/all-steps-left-side.component';
import { SectionTitle } from '../shared-components/section-title/section-title.component';
import validateEmail from 'validator/lib/isEmail';
import * as _ from 'lodash';
import { TextButton } from '../../../../../../ui/components/pure/text-button/text-button.component';

export function FindCustomerStep() {
  const { handlers, state, findCustomerStepForm } = useBookOrderActionContext();

  const form = findCustomerStepForm.watch();

  const mobilePhoneFormatter = useMobilePhoneFormatter(state.projectID);

  const theme = useTheme();
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));
  const isXS = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <form noValidate autoComplete="off" onSubmit={findCustomerStepForm.handleSubmit(handlers.onSubmitCustomerSearch)}>
      <TwoPaneModalContent
        leftDesktopWidth={4}
        rigthDesktopWidth={8}
        flexibleWidthPane="right"
        leftContent={() => <AllStepsLeftSide />}
        rightContent={() =>
          state.projectID ? (
            <Grid
              container
              sx={{ flexDirection: 'column' }}
              style={{ padding: '8px 12px', width: '100%', margin: 0 }}
              spacing={3}
            >
              <Grid>
                <SectionTitle value="Find / Create Customer" />
              </Grid>
              {state.error && (
                <Grid style={{ marginBottom: '20px' }}>
                  <Alert variant="outlined" severity="error">
                    <AlertTitle>Something went wrong</AlertTitle>
                    Error {state.error.statusCode}: {parseErrorMessage(state.error.message)}
                  </Alert>
                </Grid>
              )}
              <Grid
                container
                spacing={3}
                wrap="nowrap"
                sx={{
                  alignItems: isSM ? 'flex-start' : 'center',
                  flexDirection: isSM ? 'column' : 'row'
                }}
              >
                <Grid container style={isXS ? undefined : { maxWidth: '400px' }}>
                  <FormControl
                    control={findCustomerStepForm.control}
                    name="phone"
                    required={_.isEmpty(form.email)}
                    rules={{
                      validate: (mobile: string | undefined) => !mobile || mobilePhoneValidator(mobile)
                    }}
                    setValueAs={(mobile) => {
                      // setDisabledInput(_.isEmpty(mobile) ? null : 'email');
                      return mobilePhoneFormatter(mobile);
                    }}
                    Component={TextField}
                    ComponentProps={{
                      textFieldVariant: 'floating' as const,
                      placeholder: 'Customer mobile',
                      type: 'tel',
                      fullWidth: true,
                      desktopWidth: '100%',
                      disabled: !_.isEmpty(form.email)
                    }}
                  />
                </Grid>
                <Grid>
                  <Typography>OR</Typography>
                </Grid>
                <Grid container style={isXS ? undefined : { maxWidth: '400px' }}>
                  <FormControl
                    control={findCustomerStepForm.control}
                    name="email"
                    required={_.isEmpty(form.phone)}
                    rules={{
                      validate: (email) =>
                        !!email && !validateEmail(email) ? 'Email must be a valid email address' : true
                    }}
                    setValueAs={(email) => {
                      // setDisabledInput(_.isEmpty(email) ? null : 'mobile');
                      return email;
                    }}
                    Component={TextField}
                    ComponentProps={{
                      textFieldVariant: 'floating' as const,
                      placeholder: 'Customer email',
                      type: 'email',
                      fullWidth: true,
                      desktopWidth: '100%',
                      disabled: !_.isEmpty(form.phone)
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <></>
          )
        }
      />
      <DialogActions style={{ borderTop: '1px solid #EBEDF2', padding: '16px 24px' }}>
        <TextButton color="secondary" variant="outlined" size="small" onClick={handlers.onCancelIntent}>
          Cancel
        </TextButton>
        <TextButton color="primary" variant="outlined" type="submit" size="small">
          Submit
        </TextButton>
      </DialogActions>
    </form>
  );
}
